import React, { useEffect, useState, useMemo, useCallback } from "react";
import { useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import productActions from "../../../store/actions/items/item.actions";
import "../../../styles/components/dialogs/items/itemDetailsDialogComponent.scss";
import useAccount from "../../../hooks/useAccount";
import LoaderComponent from "../../general/LoaderComponent";
import ItemCardShoppingCartActionsComponent from "../../items/itemCard/ItemCardShoppingCartActionsComponent";
import RelatedItemsExtensionGalleryComponent from "./RelatedItemsExtensionGalleryComponent";

// ✅ Extracted Image Component
const ItemImage = ({ src, alt, isAvailable }) => (
  <div className="imageContainer">
    <img src={src || "https://via.placeholder.com/100"} alt={alt} />
    {!isAvailable && (
      <div className="unavailableSticker">
        <span>יחזור בקרוב</span>
      </div>
    )}
  </div>
);

// ✅ Extracted Shopping Cart Component
const ShoppingCartActions = ({ item }) => {
  const { isLoggedIn } = useAccount();
  if (!isLoggedIn || !item.isAvailable) return null;

  return (
    <div className="flex fdColumn gap5">
      <ItemCardShoppingCartActionsComponent props={{ product: item, style: { width: "200px" } }} />
    </div>
  );
};

// ✅ Main Component
const ItemDetailsDialogComponent = () => {
  const { isLoggedIn } = useAccount();
  const [searchParams] = useSearchParams();
  const itemId = searchParams.get("itemId");
  const dispatch = useDispatch();
  const [item, setItem] = useState(null);
  const [loading, setLoading] = useState(true);

  // Fetch Data on Mount
  useEffect(() => {
    if (itemId) fetchItemData();
  }, [itemId]);

  const fetchItemData = useCallback(async () => {
    setLoading(true);
    try {
      const response = await dispatch(productActions.getProductById(itemId));
      if (response) setItem(response);
    } catch (error) {
      console.error("Error fetching item:", error);
    }
    setLoading(false);
  }, [dispatch, itemId]);

  if (!item || loading) return <LoaderComponent />;

  return (
    <div className="dialogContainer itemDialogContainer">
      {/* Header Section */}
      <div className="itemHeader">
        <ItemImage src={item.pictureUrl} alt={item.itemDescription} isAvailable={item.isAvailable} />
        <div className="itemInfoContainer">
          <h2>{item.itemDescription}</h2>
          {/* <p className={`itemInfoContent ${item.isAvailable ? "available" : "unavailable"}`}>
            <i className="fa-solid fa-circle "></i>
            <span>{item.isAvailable ? "זמין" : "לא זמין"}</span>
          </p> */}
          {item.catalogNumber && (
            <p className="itemInfoContent">
              <strong>מק"ט:</strong>
              {item.catalogNumber}
            </p>
          )}
          {item.itemAttributes?.map((attr, index) => (
            <p className="itemInfoContent">
              <strong>{attr.attributeName}:</strong>
              {attr.attributeValue}
            </p>
          ))}

          {isLoggedIn && (
            <p className="itemInfoContent">
              <strong>מחיר:</strong>₪{item.salePriceInNIS}
            </p>
          )}
          {item.minOrderQuantity > 1 && (
            <p>
              <strong>כמות במארז:</strong> {item.minOrderQuantity}
            </p>
          )}

          <ShoppingCartActions item={item} />
        </div>
      </div>

      {/* Full Description */}
      {item.fullDescription && <p className="itemDescription">{item.fullDescription}</p>}
      {item.relatedItems && item.relatedItems.length > 0 && <h3>🔗 פריטים מקושרים</h3>}
      {item.relatedItems && item.relatedItems.length > 0 && <RelatedItemsExtensionGalleryComponent relatedItems={item.relatedItems} />}
    </div>
  );
};

export default ItemDetailsDialogComponent;
